interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const navItems = [
    { label: 'サービス', href: '#services' },
    { label: '特徴', href: '#strengths' },
    { label: '導入事例', href: '#cases' },
    { label: 'お知らせ', href: '#news' },
    { label: '会社概要', href: '#about' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-slate-900 backdrop-blur-md shadow-lg' : 'bg-slate-900'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-12">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center">
            <div className="flex items-center gap-4">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-slate-700 to-slate-800 rounded-lg flex items-center justify-center shadow-lg shadow-slate-500/20">
                  <i className="ri-building-4-line text-white text-2xl" />
                </div>
              </div>
              <div>
                <div className="text-xs tracking-wider text-white/70 transition-colors duration-300">
                  バケーションレンタル不動産仲介
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="relative px-5 py-2 text-sm font-medium text-white/90 hover:text-white transition-all duration-300 group cursor-pointer whitespace-nowrap"
              >
                {item.label}
                <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[1px] bg-white transition-all duration-300 group-hover:w-3/4" />
              </a>
            ))}
          </div>

          <button className="px-8 py-3 bg-white hover:bg-slate-50 text-slate-900 text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer">
            お問い合わせ
          </button>
        </div>
      </div>
    </nav>
  );
}
